module.exports = __webpack_public_path__ + "img/schriftzug.6398db11.svg";